module.exports = __webpack_public_path__ + "media/images/shipstation-110707cd38774c9263472cf0173d581f.svg";